export const aboutObj = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Liberia Motocycle & Tricycle Security Service",
  headline: "Secure your ride on the go",
  description:
    "The Liberia Motocycle And Tricycle Security Service INC, is a registered Liberia cyber based security institution that was established in 2024, to provide security for motocycle and Tricycle operators and users across Liberia.",
  description1:
    "We are engage in enumeration and coding of all legitimate owned motocycle and tricycle across the fifteen(15) counties. Due to higher theft rate, commercial and private owned motocycle and tricycle operators and users are venrable to criminals, because of the value and ease of resale of motorcycles and tricycles in Liberia.",
  description2:
    "Ensuring security will help protect investments and livelihoods for many families who rely on these vehicles for income and transportation. We the Liberia Motocycle And Tricycle Security Service INC (LMTSS) look up to you for your coorporation.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-1.svg"),
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const discoverObj = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Discover a lot of things",
  headline: "Sample headline about discover goes here",
  description:
    "Here we will place a detailed description of the service we are providing that you can discover here",
  buttonLabel: "Get started",
  imgStart: true,
  img: require("../../images/svg-2.svg"),
  alt: "Car",
  dark: false,
  primary: false,
  darkText: true,
};

export const signupObj = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Create an account",
  headline: "Securing your mototcycle or tricycle is extremely easy",
  description: "",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-3.svg"),
  alt: "svg3",
  dark: true,
  primary: true,
  darkText: false,
};
